export enum ChargeBeeErrorCode {
  Declined = "(card_declined)",
}

export enum UserMappingError {
  CardDeclined = "Your card was declined. Please contact your card provider."
}